import React from "react";
import Skeleton from "../../Common/Skeleton";

const OtherAccountsSkeletons = () => {
  return (
    <div className="flex flex-col h-full space-y-4">
      <div className="flex justify-between items-center mb-2">
        <Skeleton className="rounded-full h-4 w-32" />
      </div>

      <div className="search-input-wrapper flex items-center px-4 py-2 rounded-xl mb-4 border border-divider">
        <Skeleton className="rounded-full h-4 w-4 mr-2" />
        <Skeleton className="rounded-full h-4 w-full" />
      </div>

      <div className="space-y-3">
        {[1, 2, 3].map((item) => (
          <div
            key={item}
            className="other-accounts-card flex justify-between items-center"
          >
            <div className="flex items-center">
              <div className="relative">
                <Skeleton className="dark:block hidden rounded-full h-10 w-10" />
                <img
                  src="assets/gifs/loader.gif"
                  className="w-10 h-10 rounded-full block dark:hidden"
                  alt="loader"
                />
              </div>
              <div className="ml-3 space-y-2">
                <Skeleton className="rounded-full h-3 w-28" />
                <Skeleton className="rounded-full h-2 w-20 opacity-60" />
              </div>
            </div>

            {/* Right Section: Balance */}
            <div className="other-accounts-balance flex items-center">
              <Skeleton className="rounded-full h-3 w-16" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OtherAccountsSkeletons;
